import clsx from "clsx";

export interface ImageProps {
  image?: string | any;
  size?: "xs" | "sm" | "base" | "lg";
  rounded?: "base" | "lg";
}

export function Image(props: ImageProps) {
  const { image, size = "base", rounded = "none" } = props;

  const sizes = {
    xs: "h-[168px] w-full",
    sm: "h-[228px] sm:h-[264px] w-full",
    base: "sm:w-[332px] w-full h-[247px]",
    lg: "h-[168px] lg:w-full sm:h-[380px]",
  };

  const roundedValues = {
    none: "",
    base: "rounded",
    lg: "rounded-lg",
  };

  return (
    <div
      className={clsx(
        "flex-shrink-0",
        size && sizes[size],
        rounded && roundedValues[rounded]
      )}
    >
      <img
        src={image}
        alt="Automobil"
        className="object-contain w-full h-full "
      />
    </div>
  );
}

export default Image;
